import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

class LineHaulReassignmentBulkApi {
    constructor() {
        this.baseUrl = 'api/logistics/v1/lineHaulReassignment/bulk';
    }

    // eslint-disable-next-line no-unused-vars
    async bulkUpload(file, _params) {
        const respObj = { data: {}, msg: '', status: false };

        try {
            const formData = new FormData();
            formData.append('file', file);

            const url = `${this.baseUrl}/upload`;
            const response = await mmFetch(url, {
                body: formData,
                headers: {}, // Let browser set Content-Type for multipart
                method: 'POST',
            });

            if (response.status === 200) {
                const decodedResp = await response.json();
                respObj.status = true;
                respObj.msg = decodedResp.msg;
                respObj.data = decodedResp.data;
            } else {
                try {
                    const decodedResp = await response.json();
                    respObj.msg = decodedResp.msg || 'Upload failed';
                } catch (error) {
                    console.error('Error decoding response:', error);
                    respObj.msg = `Upload failed with status ${response.status}`;
                }
            }
        } catch (e) {
            // Re-throw AbortError so TanStack Query can handle cancellation
            if (e.name === 'AbortError') {
                throw e;
            }
            respObj.msg = `Upload error: ${e.message}`;
        }

        return respObj;
    }

    async bulkFetch(key, _params, signal) {
        const url = `${this.baseUrl}/fetch?key=${encodeURIComponent(key)}`;
        return mmFetchWithResponse(url, { signal });
    }

    async bulkEdit(key, _params, rowsToUpdate, rowsToDelete) {
        const url = `${this.baseUrl}/edit`;
        return mmFetchWithResponse(url, {
            body: JSON.stringify({
                key,
                rowsToDelete,
                rowsToUpdate,
            }),
            method: 'PUT',
        });
    }

    // eslint-disable-next-line no-unused-vars
    async bulkPersist(key, _params) {
        const url = `${this.baseUrl}/persist`;
        return mmFetchWithResponse(url, {
            body: JSON.stringify({ key }),
            method: 'PUT',
        });
    }
}

export const lineHaulReassignmentBulkApi = new LineHaulReassignmentBulkApi();
export { LineHaulReassignmentBulkApi };
